uniform float uTime;
uniform float uAlpha; // 天体本体と一緒にフェードイン
uniform vec3 uColor;

varying float vOffset;

void main()
{
    // 柔らかい円形の粒
    float dist = length(gl_PointCoord - 0.5);
    float disc = 1.0 - smoothstep(0.1, 0.5, dist);

    // 個体位相のゆっくりした明滅
    float twinkle = 0.3 + 0.7 * (0.5 + 0.5 * sin(uTime * 1.8 + vOffset * 6.2831 * 3.0));

    float strength = disc * twinkle * uAlpha;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(uColor * strength, strength);
}
